import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { getCookie } from "./httpClient";

import { useSelector } from "react-redux";
import Loader from "../components/Loader";

function InvestorProtectedRoute({ children }) {
  const isAuthenticated = getCookie("token");

  const profile = useSelector((store) => store.profile);
  let location = useLocation();
  if (profile?.success == true) {
    if (
      profile?.data?.individual == null &&
      profile?.data?.institution == null
    ) {
      return (
        <Navigate
          to="/investor-create/type-of-investor"
          //   state={{ from: location }} replace
        />
      );
    } else if (
      profile?.data?.institution?.applicationStage == "submitted" ||
      profile?.data?.institution?.applicationStage == "rejected"
    ) {
      return (
        <Navigate
          to={`/application-status/institution/${profile?.data?.institution?._id}`}
          //   state={{ from: location }} replace
        />
      );
    } else if (
      profile?.data?.individual?.applicationStage == "submitted" ||
      profile?.data?.individual?.applicationStage == "rejected"
    ) {
      return (
        <Navigate
          to={`/application-status/individual/${profile?.data?.individual?._id}`}
          //   state={{ from: location }} replace
        />
      );
    } else {
      return children;
    }
  } else {
    return <Loader message="Please wait!!!" />;
  }
}

export default InvestorProtectedRoute;
